import axios from 'axios';
import { Builder } from 'vue-di';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
import { AXIOS_CONFIGURATION } from '@trialcard/shared';
const knownUrls = {
    'qa': 'https://apigateway-qa.trialcard.com',
    'uat': 'https://apigateway-uat.trialcard.com',
    'training': 'https://apigateway-training.trialcard.com',
    'lab': 'https://apigateway-lab.trialcard.com',
    'prod': 'https://apigateway.trialcard.com',
};
const knownAudiences = {
    // 'qa': '',
    'uat': '0e06c9befa9d4414bcf30c69047b613d',
    'training': '0e06c9befa9d4414bcf30c69047b613d',
    'lab': '0e06c9befa9d4414bcf30c69047b613d',
    'prod': '0edf7f1a76d7471b9e2b6e8f7cbae919',
};
export function configure(container, basePath = 'qa', audience) {
    const builder = new Builder(container);
    audience = knownAudiences[basePath] || audience;
    basePath = knownUrls[basePath] || basePath;
    builder
        .registerInstance(basePath)
        .as(BASE_PATH);
    builder
        .registerInstance(audience)
        .as(AUDIENCE);
    builder
        .register(container => {
        const config = container.get(AXIOS_CONFIGURATION) || {};
        let axiosConfig = Object.assign(Object.assign({}, config), { baseURL: basePath });
        if (!axiosConfig.headers)
            axiosConfig.headers = {};
        Object.assign(axiosConfig.headers, {
            'User-Agent': 'TrialCard-Apigateway'
        });
        return axios.create(axiosConfig);
    })
        .as(AXIOS)
        .instancePerScope();
}
//# sourceMappingURL=configure.js.map